import React from "react";
import PropTypes from "prop-types";
import Image from "theme/components/atoms/Image";
import ProductOverview from "./Overview";
import ProductLabel from "./ProductLabel";
import ProductItemActions from "./ProductItemActions";
import StorefrontContent from "theme/modules/StorefrontContent";

const ProductItem = (props) => {
  return (
    <StorefrontContent type="Product" id={props.product.sku}>
      <div
        itemProp={props.itemProp}
        itemScope
        itemType="http://schema.org/Product"
        className="product-item"
      >
        <div className="product-item__image">
          <Image
            itemProp="image"
            src={props.product.imageUrl}
            alt={props.product.name}
            format="small"
            appearance="full"
            sizes={props.imageSizes}
            priority={props.imagePriority}
          />
        </div>

        <div className="product-item__label">
          <ProductLabel product={props.product} />
        </div>

        <div className="product-item__overview">
          <ProductOverview
            product={props.product}
            products={props.products}
            breadcrumb={props.breadcrumb}
            location={props.location}
            index={props.index}
          />
        </div>
        <div className="product-item__actions">
          <ProductItemActions product={props.product} />
        </div>
        <meta itemProp="category" content={props.categoryName} />
      </div>
    </StorefrontContent>
  );
};

ProductItem.propTypes = {
  categoryName: PropTypes.string,
};

export default ProductItem;
